export const common = {
  // Header Navigation
  nav: {
    home: 'HOME',
    brandStory: 'BRAND STORY',
    whoWeServe: 'WHO WE SERVE',
    products: 'PRODUCTS',
    privateLabel: 'PRIVATE LABEL',
    shop: 'SHOP',
    contact: 'CONTACT',
  },
  
  // Product Categories
  productCategories: {
    roastedCoffee: 'Roasted Coffee',
    pods: 'Pods',
    compatibleCapsules: 'Compatible Capsules',
    milkshakes: 'Milkshakes',
    horeca: 'HoReCa',
    tea: 'Tea',
    machines: 'Coffee & Tea Machines',
  },
  
  // Common Actions
  actions: {
    seeDetails: 'See Details',
    learnMore: 'Learn More',
    contactUs: 'Contact Us',
    viewAll: 'View All',
  },
  
  // Footer
  footer: {
    tagline: 'Where vision becomes form',
    description: 'Premium coffee and HoReCa solutions crafted for excellence. Rooted in Italian heritage, engineered for global hospitality.',
    address: 'ADDRESS',
    email: 'EMAIL',
    copyright: '© 2026 LUCENDO. All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms',
    poweredBy: 'Powered by Akıllı Mum',
  },
};
